<template>
  <div id="tamegakiApp">
    <div class="container mx-auto">
      <div
        class="message-wrapper"
        v-for="user in state.data"
        :key="user.タイムスタンプ"
      >
        <Message :user="user" />
      </div>
    </div>
  </div>
</template>

<style scoped>
@media print {
  .container {
    width: 100%;
    max-width: 100%;
  }
  .message-wrapper {
    min-height: 25vh;
  }
}
</style>

<script>
import axios from 'axios'
import { defineComponent, reactive, onMounted, computed } from 'vue'
import Message from './Message.vue'

export default defineComponent({
  components: { Message },
  name: 'tamegakiApp',
  setup() {
    const state = reactive({
      data: null
    })
    async function getRate() {
      state.data = await axios
        .get(
          'https://script.google.com/macros/s/AKfycbx4RhqNmcSvqwJw-ckg-oxKKkVhm3U91ZmM1KA_cHGFQRGYECfgy43HKRDGkQC-_NI/exec'
        )
        .then(response => (state.data = response.data.slice().reverse()))
    }
    onMounted(() => {
      getRate()
    })
    return {
      state,
      getRate
    }
  }
})
</script>
